import { graphql, useStaticQuery } from "gatsby";

export const useThemeSettings = () => {
  const data = useStaticQuery(
    graphql`
      query ThemeSettingsData {
        wp {
          themeGeneralSettings {
            careerSettings {
              careerFooter
            }
            formBlockSettings {
              headline
              footerBlocks {
                headline
                text
              }
              backgroundImage {
                ...ImgBackground
              }
              formId
            }
            settingsGeneral {
              share {
                mailBody
                mailSubject
                twitterText
              }
            }
            cookieNotice {
              text
              buttonLabel
            }
          }
        }
      }
    `
  )
  return data;
}